<template>
    <div class="card-info" :class="`card-info--${title.toLowerCase()}`">
        <div class="card-info-header">
            <div class="title-with-icon">
                <div class="section-icon-badge" :class="`badge-${title.toLowerCase()}`">
                    <feather-icon :icon="sectionIcon" size="16" />
                </div>
                <h2>{{ sectionTitle }}</h2>
            </div>
        </div>
        <div
            :class="[
                'infos-container',
                { 'order-card': title === 'Order' },
                { 'operation-card': title === 'Operation' },
                { 'attributes-card': title === 'Attributes' },
                { 'observation-card': title === 'Observation' || title === 'Observations' },
            ]"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoCard",
    props: {
        title: {
            type: String,
            default: "Order",
            required: true
        }
    },
    computed: {
        sectionTitle() {
            if (this.title === "Observations" || this.title === "Observation") {
                return this.$t("ProductionProgress.InfoTab.Observations.Title") || "Observações";
            }
            return this.$t(`ProductionProgress.InfoTab.${this.title}.Title`) || this.title;
        },
        sectionIcon() {
            switch (this.title) {
                case "Order":
                    return "FileTextIcon";
                case "Operation":
                    return "CpuIcon";
                case "Attributes":
                    return "SlidersIcon";
                case "Observations":
                case "Observation":
                    return "MessageSquareIcon";
                default:
                    return "InfoIcon";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-info {
    padding: 18px 0 20px;
    border-bottom: 1px solid #ede5e0;

    &:last-child {
        padding-bottom: 24px;
        border-bottom: none;
    }

    .card-info-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;

        .title-with-icon {
            display: flex;
            align-items: center;
            gap: 10px;

            .section-icon-badge {
                width: 32px;
                height: 32px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                &.badge-order {
                    background: #ffede2;
                    color: #974900;
                }

                &.badge-operation {
                    background: #eef2f5;
                    color: #455a64;
                }

                &.badge-attributes {
                    background: #f3e8ff;
                    color: #7952b3;
                }

                &.badge-observations,
                &.badge-observation {
                    background: #fff4e5;
                    color: #b76e00;
                }
            }

            h2 {
                font-family: "Raleway", sans-serif;
                font-weight: 700;
                font-size: 18px;
                line-height: 24px;
                color: #2e2621;
                margin: 0;
            }
        }
    }

    .infos-container {
        gap: 12px 14px;
        display: grid;

        &.order-card {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        &.operation-card {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        &.attributes-card {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        &.observation-card {
            grid-template-columns: 1fr;
        }
    }
}

@media (max-width: 900px) and (min-width: 600px) {
    .card-info {
        .infos-container {
            &.order-card,
            &.operation-card,
            &.attributes-card {
                grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }
        }
    }
}

@media (max-width: 599px) {
    .card-info {
        .infos-container {
            &.order-card,
            &.operation-card,
            &.attributes-card {
                grid-template-columns: 1fr !important;
            }
        }
    }
}
</style>
